(function(){
  'use strict';

  var historico = {
    template: require('./history.html'),
    controller: 'HistoricoCtrl'
  };

  angular
  .module('mandaeApp')
  .component('historico', historico);

}());